
import ModalWindow from '../modal-window';
import { ModalSlotName } from '../enums';
import ModalCommonProps from '../mixins/ModalCommonProps';

export default {
  name: 'IframeModal',
  components: {
    ModalWindow,
  },
  mixins: [ModalCommonProps],
  data() {
    return {
      ModalSlotName,
    };
  },
};
